import { useState } from "react";
import Checkbox from "./Checkbox";
import Select from "./Select";
import strings from "@/language/Swedish";
import Icon from "./Icon";
import { Icons, IconSize } from "@/enums";

interface MapFilterOption {
  label: string;
  value: string;
}

interface MapFilterProps {
  setMapTypeId: (id: string) => void;
  mapTypeIds: MapFilterOption[];
  setShowPropertyLines: (value: boolean) => void;
  showPropertyLines: boolean;
}

export default function MapFilter({
  setMapTypeId,
  mapTypeIds,
  setShowPropertyLines,
  showPropertyLines,
}: MapFilterProps) {
  const [isCollapsed, setIsCollapsed] = useState(true);

  const handleTogglePropertyLines = () => {
    setShowPropertyLines(!showPropertyLines);
  };

  return (
    <div className="p-2 bg-white w-full rounded-md drop-shadow-[0_0px_5px_rgba(0,0,0,0.15)] w-[210px]">
      <div className={`flex-col gap-4 md:flex`}>
              <button
        onClick={() => setIsCollapsed(!isCollapsed)}
        className={`w-full flex justify-between items-center font-medium md:hidden ${!isCollapsed && 'mb-4'}`}
      >
        <span className="text-sm">{isCollapsed ? strings.data.showMapSettings : strings.data.hideMapSettings}</span>
        <span>{isCollapsed ? <Icon icon={Icons.chevronUp} size={IconSize.medium} /> : <Icon icon={Icons.chevronDown} size={IconSize.medium}/> }</span>
      </button>
            <div className={`${isCollapsed ? "hidden" : "flex"} flex-col gap-4 md:flex`}>
      
        <Checkbox
        tooltip={strings.data.sourceLantmateriet}
          label={strings.dashboard.showPropertyLinesLabel}
          id="property-lines-checkbox"
          onToggle={handleTogglePropertyLines}
          isChecked={showPropertyLines}
        />
        <Select
          options={mapTypeIds}
          handleChange={(e) => setMapTypeId(e as string)}
        />
      </div>
      </div>
    </div>
  );
}
